import {Component, OnInit} from '@angular/core';

import {ActivatedRoute} from '@angular/router';

import {SearchService} from '../search.service';
import {BehaviorSubject} from 'rxjs/internal/BehaviorSubject';
import {LibraryList} from "./bottom-list/library-list/library-list.model";
import {BingMapService} from "../../bing-maps/service/bing-map.service";
import {ObjectDetailService} from "./object-detail.service";

@Component({
  selector: 'app-object-detail',
  templateUrl: './object-detail.component.html',
  styleUrls: ['./object-detail.component.scss']
})
export class ObjectDetailComponent implements OnInit {

  record: any;
  expressions: any[] = [];
  materializations: any[] = [];
  matIds$ = new BehaviorSubject<number[]>([]);
  recordId;
  exprLength = 0;
  materLength = 0;

  libraryList: LibraryList;
  nlpId;
  workTitleOfOrigPref;
  creator;

  constructor(private route: ActivatedRoute, private searchService: SearchService, private mapsService: BingMapService,
              private objectDetailsService: ObjectDetailService) {
  }

  ngOnInit() {
    this.route.params.subscribe((params: { id: number, type: string }) => {
      if (params && params.id && params.type) {
        this.recordId = false;
        this.recordId = params.id;
        this.getRecord(params.type, params.id);
        this.getLibraries(this.materializations);
      }
    });

  }

  getRecord(type: string, recId: number): void {
    this.searchService.findObject(type, recId)
      .subscribe(record => {
          this.record = record;
          this.nlpId = this.getNlpId(this.record);
          this.workTitleOfOrigPref = this.getWorkTitleOfOrigPref(this.record);
          this.creator = this.getCreator(this.record);
          this.record.id = recId;
        }
      );
    this.getRecordDetails(recId);
  }

  getRecordDetails(recId: number): void {
    this.searchService.findExpressions(recId, 0)
      .subscribe(expressions => {
          this.expressions = expressions['search'];
          this.exprLength = this.expressions ? this.expressions.length : 0;
        }
      );
    this.searchService.findMaterializations(recId, 0)
      .subscribe(materializations => {
        this.materializations = materializations['search'];
        this.materLength = this.materializations ? this.materializations.length : 0;
        if (materializations.totalPages > materializations.pageNumber) {
          this.agregateMaterializations(recId, materializations.totalPages, materializations.pageNumber, this.materializations);
        } else {
          this.matIds$.next(this.getMaterializationsIds());
        }
        }
      );
  }

  public agregateMaterializations(record, total , current , data){
      this.searchService.findMaterializations(record, current).subscribe(mater => {
        data = data.concat(mater.search);
        this.materializations = data;
        this.materLength = this.materializations ? this.materializations.length : 0;
        if (mater.totalPages > mater.pageNumber) {
          this.agregateMaterializations(record, mater.totalPages, mater.pageNumber, this.materializations);
        } else {
          this.matIds$.next(this.getMaterializationsIds());
        }
      });

  }

  private getLibraries(materializations) {
      this.objectDetailsService.getLibrariesWork(materializations).subscribe((data: any) => {
        this.libraryList = new LibraryList(data);
    });

  }

  getMaterializationsIds() {
    if (this.materializations) {
      return this.materializations.map((mat) => {
        return mat.id;
      });
    }else{
      return [-1];
    }
  }

  getWorkType() {
    return this.record['work_form'];
  }

  getOnlineVersionAvailable(): boolean {
    if (this.libraryList && this.libraryList.libraries)
    for (const value of this.libraryList.libraries) {
      if (value.items.filter((item: {publicDomain: boolean})=> item.publicDomain).length > 0) {
        return true;
      }
    }
    return false;
  }

  getNlpId(record) {
    return record['search_identity'].find(item => item.includes('(PL)')).replace('(PL)', '');
  }

  getWorkTitleOfOrigPref(record) {
    return record['work_title_of_orig_pref'];
  }

  getCreator(record) {
    let workPresentationMainCreatorArray = record['work_presentation_main_creator'];
    if (workPresentationMainCreatorArray.length > 0) {
      let workPresentationMainCreatorFirstObject = workPresentationMainCreatorArray[0];
      let workPresentationMainCreatorObjectValueArray = workPresentationMainCreatorFirstObject['value'];
      let workPresentationMainCreatorObjectValueObject = workPresentationMainCreatorObjectValueArray[0];
      return workPresentationMainCreatorObjectValueObject['value'];
    } else {
      return '';
    }
  }
}
